import React, { useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const HorizontalBarChart = ({ chartData }) => {
  const chartRef = useRef(null);

  if (!chartData) {
    return <div>No data</div>;
  }

  const {
    chart: { height = 400,} = {},
    title: { text: titleText = "" } = {},
    xAxis: { categories = [] } = {},
    series = [],
    colors = [],
    yAxis: yAxisConfig = {},
    tooltip = {},
    plotOptions: plotOptionsFromProps = {},
    credits: creditsConfig = { enabled: false },
  } = chartData;

  const plotOptions = {
    bar: {
      colorByPoint: true,
      pointPadding: 0.2,
      borderWidth: 0,
      dataLabels: {
        enabled: true,
      },
      cursor: "pointer",
      ...plotOptionsFromProps.bar,
      point: {
        events: {
          click: function () {
            if (chartData.onBarClick) {
              chartData.onBarClick(this);
            }
          },
          ...(plotOptionsFromProps.series?.point?.events || {}),
        },
      },
    },
    ...plotOptionsFromProps,
  };

  const options = {
    chart: {
      type: "bar",
      height,
    },
    title: {
      text: titleText,
    },
    xAxis: {
      categories,
      title: {
        text: null,
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      ...yAxisConfig,
      min: yAxisConfig.min ?? 0,
      title: {
        text: yAxisConfig.title?.text || null,
        align: yAxisConfig.title?.align || "high",
      },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: yAxisConfig.gridLineWidth ?? 0,
    },
    tooltip,
    plotOptions,
    colors,
    series,
    credits: creditsConfig,
  };

  return (
    <div style={{ width: "100%", height }}>
      <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
    </div>
  );
};

export default HorizontalBarChart;
